import { useMutation, useQueryClient } from "@tanstack/react-query";
import { buildGetCmaPresentationEditQueryKey } from "./useGetCmaPresentationEdit";
import { getPartialCmaPresentationApiClient } from "../../apis/comps/presentation-api-client/api-client-factory";
import { SectionConfig } from "@cma/presentation-generation-logic";
import { CMA_SCOPE_KEY } from "./cma.key";

type Props = {
  onSuccess?: () => void;
  onSettled?: () => void;
};

type Params = {
  id: string;
  sectionsConfig: SectionConfig[];
  themeId?: string | null;
};

export const useUpdatePresentationConfig = (props?: Props) => {
  const { onSuccess, onSettled } = props || {};
  const presentationApiClient = getPartialCmaPresentationApiClient();

  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const { id, sectionsConfig, themeId } = params;
      const response = await presentationApiClient.putPresentationConfig({
        id,
        sections: sectionsConfig,
        themeId,
      });

      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: buildGetCmaPresentationEditQueryKey(id),
        });
      }, 2000);
      onSuccess?.();
      return response;
    },
    onSettled: () => {
      onSettled?.();
    },
    onError: async (error, { id }) => {
      console.error(
        `Failed to update CMA presentation config with id ${id}`,
        error,
      );
    },
    mutationKey: [CMA_SCOPE_KEY, "update-presentation-config"],
  });

  return mutation;
};
